import type { PermissionEntry } from '@repo/constants'
import { atomWithStorage } from 'jotai/utils'
import { store } from '.'

const PERMISSIONS_KEY = 'dp_permissions'

const permissionsAtom = atomWithStorage<PermissionEntry[]>(PERMISSIONS_KEY, [], undefined, {
  getOnInit: true,
})

export const setPermissions = (perms: PermissionEntry[]) => store.set(permissionsAtom, perms)
export const clearPermissions = () => {
  store.set(permissionsAtom, [])
}
